import { Box, Typography } from "@mui/material";
import Lottie from "react-lottie-player";
import useTranslationSetup from "../../utils/useTranslationSetup";
import loading from "../../assets/LottieFiles/resultLoading.json";
import "./styles.css";

const LoadingWrapper = ({ type }) => {
  const { t } = useTranslationSetup();

  return (
    <Box className="loader-container">
      <Box className="loader-content">
        <Lottie loop animationData={loading} play />
        {type === "isLoading" && (
          <>
            <Typography className="loader-heading">
              {t("loading")}...
            </Typography>
          </>
        )}
        {type === "resultLoading" && (
          <>
            <Typography className="custom-ff-regular" fontSize="20px">
              {t("processing_result")}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default LoadingWrapper;
